import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
//import ReactGA from "react-ga4";
import ReCAPTCHA from "react-google-recaptcha";
// Material Kit 2 React components
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
// Images
import { Card, CardContent, Button } from "@mui/material";
import RotatingCard from "./RotatingCard";
import RotatingCardFront from "./RotatingCardFront";
import RotatingCardBack from "./RotatingCardBack";
//import { useTranslation } from "react-i18next";
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import {
  CREATE_STRATEGYSWOT,
  FIND_STRATEGYSWOTS_BY_MUNICIPALITY,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const SWOT = ({ selectedKunta, setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  const [strengths, setStrengths] = useState([]);
  const [weakness, setWeakness] = useState([]);
  const [opportunities, setOpportunities] = useState([]);
  const [threats, setThreats] = useState([]);
  const [strengthssaved, setStrengthssaved] = useState([]);
  const [weaknesssaved, setWeaknesssaved] = useState([]);
  const [opportunitiessaved, setOpportunitiessaved] = useState([]);
  const [threatssaved, setThreatssaved] = useState([]);
  const [votes, setVotes] = useState([]);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted] = useState(false);
  const [executing] = useState(false);
  //const [swots, setSwots] = useState([]);
  //const [sswots, setSswots] = useState("");
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  /*useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = 0;
    if (localStorage.getItem("id") !== undefined) {
      id = localStorage.getItem("id");
    }
    //console.log(id);
    /*ReactGA.event({
      category: "SWOT",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,_/
    }); // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });
    */
  //}, []);
  const [createStrategyswot] = useMutation(CREATE_STRATEGYSWOT, {
    refetchQueries: [
      { query: FIND_STRATEGYSWOTS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const sswotssw = useQuery(FIND_STRATEGYSWOTS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });

  useEffect(() => {
    let sswotss = [];
    //console.log(sswotssw);
    //let municipalitiess = [];
    if (sswotssw.data) {
      sswotss = sswotssw.data.findStrategyswotsByMunicipality;
      //setOrgans(organss);
      //console.log(sswotss);
      let stre = sswotss.filter((a) => a.swotclass === "Strength");
      setStrengthssaved(stre);
      let weak = sswotss.filter((a) => a.swotclass === "Weakness");
      setWeaknesssaved(weak);
      let oppo = sswotss.filter((a) => a.swotclass === "Opportunity");
      setOpportunitiessaved(oppo);
      let thre = sswotss.filter((a) => a.swotclass === "Threat");
      setThreatssaved(thre);
      //let secs = sswotss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsswots(secs);
      //setSwots(sswotss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sswotssw]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    for (let i = 0; i < strengths.length; i++) {
      createStrategyswot({
        variables: {
          swottext: strengths[i],
          swotclass: "Strength",
          strategydatetime: pvm.toString(),
          municipality: selectedKunta,
          userid: localStorage.getItem("id"),
        },
      });
    }
    for (let i = 0; i < weakness.length; i++) {
      createStrategyswot({
        variables: {
          swottext: weakness[i],
          swotclass: "Weakness",
          strategydatetime: pvm.toString(),
          municipality: selectedKunta,
          userid: localStorage.getItem("id"),
        },
      });
    }
    for (let i = 0; i < opportunities.length; i++) {
      createStrategyswot({
        variables: {
          swottext: opportunities[i],
          swotclass: "Opportunity",
          strategydatetime: pvm.toString(),
          municipality: selectedKunta,
          userid: localStorage.getItem("id"),
        },
      });
    }
    for (let i = 0; i < threats.length; i++) {
      createStrategyswot({
        variables: {
          swottext: threats[i],
          swotclass: "Threat",
          strategydatetime: pvm.toString(),
          municipality: selectedKunta,
          userid: localStorage.getItem("id"),
        },
      });
    }
    setThreats([]);
    setOpportunities([]);
    setWeakness([]);
    setStrengths([]);
    window.confirm("Kiitos kommentistasi");
    setVerified(!verified);
  };
  const handleRemovethreat = (event) => {
    //console.log(event);
    let newth = threats.filter((cont) => {
      return cont !== event;
    });
    //console.log(newth);
    setThreats(newth);
  };

  const handleRemovestrength = (event) => {
    //console.log(event);
    let newst = strengths.filter((cont) => {
      return cont !== event;
    });
    //console.log(newst);
    setStrengths(newst);
  };

  const handleRemoveweakness = (event) => {
    //console.log(event);
    let newwe = weakness.filter((cont) => {
      return cont !== event;
    });
    //console.log(newwe);
    setWeakness(newwe);
  };

  const handleRemoveopportunities = (event) => {
    //console.log(event);
    let newop = opportunities.filter((cont) => {
      return cont !== event;
    });
    //console.log(newop);
    setOpportunities(newop);
  };

  function addThreat(value) {
    //console.log(value);
    setThreats((threats) => [...threats, value]);
    //console.log(threats);
  }

  function addStrengths(value) {
    //console.log(value);
    setStrengths((strengths) => [...strengths, value]);
    //console.log(strengths);
  }

  function addOpportunities(value) {
    //console.log(value);
    setOpportunities((opportunities) => [...opportunities, value]);
    //console.log(opportunities);
  }

  function addWeakness(value) {
    //console.log(value);
    setWeakness((weakness) => [...weakness, value]);
    //console.log(weakness);
  }
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategyswotid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategyswotid === p).length;
  }
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    //console.log(token);
    setVerified(!verified);
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.header")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              <Grid item xs={12} md={6} />
              <Grid item xs={12} md={6}></Grid>
              <Grid item xs={12} md={6}>
                <RotatingCard>
                  <RotatingCardFront
                    color="success"
                    image={bgFront}
                    icon="touch_app"
                    title={t("swot.strengths")}
                    description={t("swot.strengthstext")}
                  />
                  <RotatingCardBack
                    image={bgBack}
                    title={t("swot.addstrengths")}
                    add={addStrengths}
                    action={{
                      type: "internal",
                      route: "/sections/page-sections/page-headers",
                      label: t("swot.save"),
                    }}
                  />
                </RotatingCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <RotatingCard>
                  <RotatingCardFront
                    color="error"
                    image={bgFront}
                    icon="touch_app"
                    title={t("swot.weaknesses")}
                    description={t("swot.weaknessestext")}
                  />
                  <RotatingCardBack
                    image={bgBack}
                    title={t("swot.addweaknesses")}
                    add={addWeakness}
                    action={{
                      type: "internal",
                      route: "/sections/page-sections/page-headers",
                      label: t("swot.save"),
                    }}
                  />
                </RotatingCard>
              </Grid>
              <br />
              <Grid item xs={12} md={6}>
                <RotatingCard>
                  <RotatingCardFront
                    image={bgFront}
                    icon="touch_app"
                    color="secondary"
                    title={t("swot.opportunities")}
                    description={t("swot.opportunitiestext")}
                  />
                  <RotatingCardBack
                    image={bgBack}
                    title={t("swot.addopportunities")}
                    add={addOpportunities}
                    action={{
                      type: "internal",
                      route: "/sections/page-sections/page-headers",
                      label: t("swot.save"),
                    }}
                  />
                </RotatingCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <RotatingCard>
                  <RotatingCardFront
                    image={bgFront}
                    color="warning"
                    icon="touch_app"
                    title={t("swot.threats")}
                    description={t("swot.threatstext")}
                  />
                  <RotatingCardBack
                    image={bgBack}
                    title={t("swot.addthreats")}
                    add={addThreat}
                    action={{
                      type: "internal",
                      route: "/sections/page-sections/page-headers",
                      label: t("swot.save"),
                    }}
                  />
                </RotatingCard>
              </Grid>
            </Grid>
            <br />
            <MKTypography variant="h3" gutterBottom>
              {t("swot.strengths")}
            </MKTypography>
            <table style={{ width: "100%", textAlign: "center" }}>
              {strengths.map((item) => (
                <tr key={item}>
                  <td>{item}</td>
                  <td>
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleRemovestrength(item)}
                    >
                      {t("swot.delete")}
                    </Button>
                  </td>
                </tr>
              ))}
            </table>
            <br />
            <MKTypography variant="h3" gutterBottom>
              {t("swot.weaknesses")}
            </MKTypography>
            <table style={{ width: "100%", textAlign: "center" }}>
              {weakness.map((item) => (
                <tr key={item}>
                  <td>{item}</td>
                  <td>
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleRemoveweakness(item)}
                    >
                      {t("swot.delete")}
                    </Button>
                  </td>
                </tr>
              ))}
            </table>
            <br />
            <MKTypography variant="h3" gutterBottom>
              {t("swot.opportunities")}
            </MKTypography>
            <table style={{ width: "100%", textAlign: "center" }}>
              {opportunities.map((item) => (
                <tr key={item}>
                  <td>{item}</td>
                  <td>
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleRemoveopportunities(item)}
                    >
                      {t("swot.delete")}
                    </Button>
                  </td>
                </tr>
              ))}
            </table>
            <br />
            <MKTypography variant="h3" gutterBottom>
              {t("swot.threats")}
            </MKTypography>
            <table style={{ width: "100%", textAlign: "center" }}>
              {threats.map((item) => (
                <tr key={item}>
                  <td>{item}</td>
                  <td>
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleRemovethreat(item)}
                    >
                      {t("swot.delete")}
                    </Button>
                  </td>
                </tr>
              ))}
            </table>
            <br />
            <br />
            <div style={{ width: "100%", marginLeft: "30%" }}>
              <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
            </div>
            <br />
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={handleSubmit}
              disabled={!verified}
              executing={executing}
              submitted={submitted}
            >
              {t("swot.save")}
            </Button>
          </Container>
        </CardContent>
      </Card>
      <MKTypography variant="h2" gutterBottom>
        {t("swot.saved")}
      </MKTypography>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.strengths")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {strengthssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.weaknesses")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {weaknesssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.opportunities")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {opportunitiessaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.threats")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {threatssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
    </>
  );
};

export default SWOT;
